/**
 * GLOBAL NAVIGATION
 *
 * Navigation, subnavigation handlers, binds
 *
 */
VP = window.VP || {};

(function( $ ) {
	var $window = $(window);
	var $body = $('body');
	var $wrapper = $('.wrap.container');
	// Elements to which body width has to be applied when nav is open
	var $limitWidthElements = $('.vp-header, .vp-module__featured-hero, .js-cinematic-hero').add($wrapper);

	VP.nav = {
		wrapper: $('.vp-header'),
		top: $window.height() / 4,
		window: $window,
		isOpen: false, // Flag for nav state
		isDocked: false,
		isForcedDock: false,
		current: null,

		init: function () {
			var _this = this;
			_this.dock();
			_this.eventHandlers();
		},

		toggle: function () {
			// Toggle menu open/close
			if (!this.isOpen) {
				this.open();
			} else {
				this.close();
			}
		},

		eventHandlers: function () {
			var _this = this;
		  
			// Docker
			_this.window.on("scroll", function (e) {
			  _this.dock();
			});
		  
			// Update settings
			_this.window.on("resize", function (e) {
			  _this.updateSettings();
			});
		  
			// Main Menu Toggler
			$(".vp-nav__hamburger", _this.wrapper).click(function (e) {
			  e.preventDefault();
			  if (!_this.wrapper.hasClass("vp-header--opened")) {
				_this.open();
			  } else {
				_this.close();
			  }
		  
			  $("body .wrap.nav-opened").one("mousedown", function () {
				_this.close();
			  });
			});
		  
			// Overlay click to close the menu
			$(document).on("click", function (e) {
			  const $target = $(e.target);
			  const $menu = $(".vp-nav");
			  // Check if click is outside the menu
			  if (
				_this.isOpen &&
				!$target.closest($menu).length && // Not inside the menu
				!$target.closest(".vp-nav__hamburger").length // Not the hamburger
			  ) {
				_this.close();
			  }
			});
		  
			// Sub Menu Toggler
			$(".menu-item-has-children > a", _this.wrapper).click(function (e) {
			  var _this = this;
			  VP.nav.current = $(this).parent();
			  $(".menu-item-has-children div.sub-menu", _this.wrapper)
				.not($(".menu-item-has-children div.sub-menu", VP.nav.current))
				.fadeOut(100);
			  $(".menu-item-has-children", _this.wrapper)
				.not(VP.nav.current)
				.removeClass("opened");
		  
			  if (VP.nav.current.hasClass("hide-child-in-mobile") && VP.helpers.isMobileSize()) {
				return;
			  }
		  
			  e.preventDefault();
		  
			  if (!VP.nav.current.hasClass("opened")) {
				var _t = 0;
				var _label = $(this).text();
				VP.helpers.firecustomGTMEvent("mainNav", _label, "Main Menu Open");
		  
				_t = VP.nav.current.index() * 50 + 8;
		  
				if (VP.helpers.isMobileSize()) {
				  $("div.sub-menu", VP.nav.current).slideDown(200);
				  $(".vp-nav", _this.wrapper)
					.stop()
					.animate({ scrollTop: _t }, { duration: 400, queue: false });
				} else {
				  $("div.sub-menu", VP.nav.current).slideDown(200);
				}
		  
				VP.nav.current.addClass("opened");
				VP.nav.open();
			  } else {
				VP.nav.current.removeClass("opened");
				if (VP.helpers.isDesktopSize()) {
				  $("div.sub-menu", VP.nav.current).fadeOut(100, function () {
					VP.nav.close();
				  });
				}
			  }
			});
		  
			$(document).mouseup(function (e) {
			  var container = $(".vp-header, .vp-header .sub-menu, .vp-header .vp-search");
			  if (
				!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				(VP.nav.isOpen || VP.search.isOpen)
			  ) {
				if (VP.nav.isOpen) {
				  VP.nav.closeSubMenu();
				} else {
				  VP.search.close();
				}
			  }
			});
		  
			// Close on click
			$(".sub-menu__close", _this.wrapper).on("click", function (e) {
			  e.preventDefault();
			  VP.nav.closeSubMenu();
			});
		  
			// Resize listener
			VP.documentEvents.onResize(function () {
			  if (_this.isOpen) {
				_this.setElementWidths();
			  }
			});
		  
			// Events handler for links that go to Press Release module - #pr-nav-deep
			if (window.location.hash && document.getElementById("pr-nav-deep")) {
			  $("body").css("visibility", "hidden");
		  
			  var detail_module_reveal_check = setInterval(function () {
				var reveal_complete = $(".vp-content-body-module__details").hasClass("js-reveal--done");
				if (reveal_complete) {
				  _this.reRenderModules();
				  clearInterval(detail_module_reveal_check);
				}
			  }, 100);
		  
			  // Fallback in case js-reveal is removed
			  setTimeout(function () {
				_this.reRenderModules();
			  }, 500);
			}
		  
			$("nav a[href*='#pr-nav-deep']").on("click touchend", function (e) {
			  _this.reRenderModules();
			  var golink = $(this).attr("href");
		  
			  if ($("#pr-nav-deep").length > 0) {
				if (golink && golink.indexOf("filtered=") >= 0) {
				  golink = golink.split("filtered=")[1];
				  if (golink.indexOf("#")) {
					golink = golink.split("#")[0];
				  }
				  var $option = $(
					".vp-all-press-release__category option[value='" + golink + "']"
				  );
				  if ($option.length == 1) {
					VP.helpers.setQParams({ filtered: golink }, { type: "replace" });
					$(".vp-all-press-release__category").val(golink);
					return false;
				  }
				} else {
				  VP.helpers.setQParams({ filtered: "" }, { type: "replace" });
				  $(".vp-all-press-release__category").val("");
				  return false;
				}
			  }
			  return true;
			});
		  
			window.addEventListener("hashchange", function () {
			  _this.reRenderModules();
			});
		  
			_this.isTouch();
			_this.isSafari();
		  },
		  
		  /* Changes display of vp-modules to force a
		   * re-render to correct the spacing when deeplinking.
		   * @param millisecond to turn module back on
		   */
		  reRenderModules: function (time) {
			// console.log("rerender nav");
			// Page must have pr-nav-deep
			if (document.getElementById("pr-nav-deep")) {
			  var timeoutNum = time || 0;
			  $(".vp-modules").css("display", "none");
			  $(".vp-module__featured-hero--intro").css("display", "none");
		  
			  if (VP.nav.isOpen) {
				VP.nav.close();
			  }
		  
			  // Need to add setTimeout for modules to re-render.
			  setTimeout(function () {
				$(".vp-modules").css("display", "block");
				$(".vp-module__featured-hero--intro").css("display", "block");
				var _top = $("#pr-nav-deep").offset().top;
		  
				if ($(window.location.hash).length) {
				  var _top = $(window.location.hash).offset().top;
				}
				$("html, body").animate(
				  { scrollTop: _top - 100 + "px" },
				  600,
				  function () {
					$("body").css("visibility", "visible");
				  }
				);
			  }, timeoutNum);
			}
		  },
		  
		  isTouch: function () {
			var supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
		  
			if (true === supportsTouch) {
			  $("body").addClass("has-touch");
			}
		  },
		  
		  updateSettings: function () {
			var _this = this;
			_this.top = _this.window.height() / 4;
		  },
		  
		  dock: function (forced) {
			var _this = this;
			forced = forced || _this.isForcedDock;
			if (
			  (!_this.wrapper.hasClass("vp-header--docked") &&
				_this.window.scrollTop() > _this.top) ||
			  forced
			) {
			  _this.wrapper.addClass("vp-header--docked");
			  $("body, .wrap.container").addClass("nav-docked");
			  _this.isDocked = true;
		  
			  if (forced) {
				_this.isForcedDock = true;
			  }
			} else if (
			  _this.wrapper.hasClass("vp-header--docked") &&
			  _this.window.scrollTop() <= _this.top
			) {
			  _this.wrapper.removeClass("vp-header--docked");
			  $("body, .wrap.container").removeClass("nav-docked");
			  _this.isDocked = false;
			}
		  },
		  
		  open: function () {
			var _this = this;
			_this.isOpen = true;
			VP.search.close();
		  
			if (!$body.hasClass("nav-opened")) {
			  _this.setElementWidths();
			}
		  
			_this.wrapper.addClass("vp-header--opened");
			$body.add($wrapper).addClass("nav-opened");
		  },
		  
		  close: function () {
			var _this = this;
			_this.isOpen = false;
			_this.wrapper.removeClass("vp-header--opened");
			$("body, .wrap.container").removeClass("nav-opened");
			$(".menu-item-has-children", _this.wrapper).removeClass("opened");
			$(".menu-item-has-children div.sub-menu", _this.wrapper).removeAttr("style");
			$(".vp-nav").removeAttr("style");
			_this.unsetElementWidths();
		  },
		  
		  closeSubMenu: function () {
			VP.nav.current.removeClass("opened");
			if (VP.helpers.isDesktopSize()) {
			  $("div.sub-menu", VP.nav.current).fadeOut(100, function () {
				VP.nav.close();
			  });
			}
		  },
		  
		  setElementWidths: function () {
			var bodyWidth = $body.innerWidth();
			// Apply body widths to elements
			$limitWidthElements.width(bodyWidth);
		  },
		  
		  unsetElementWidths: function () {
			$limitWidthElements.css("width", "");
		  },
		  
		  isSafari: function () {
			// Detect if Safari Browser as of 2017
			var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		  
			if (isSafari) {
			  $("body").addClass("is-safari");
			}
		},
	};
})(jQuery);
		  
